const eliminarPuntosDuplicados = arr => {
  // eslint-disable-next-line eqeqeq
  return arr.filter((point, index, array) => array.findIndex(t => t.lat == point.lat && t.lng == point.lng) == index);
};
export default eliminarPuntosDuplicados;
